module.exports = "<electra-search-results [ngClass]=\"searchResultsClass\"\n\t\t\t\t\t\t\t\t\t\t\t\t[ngStyle]=\"searchResultsStyle\"></electra-search-results>\n<electra-search [ngClass]=\"searchClass\"></electra-search>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/electraLib/component/searchWrapper/searchWrapper.component.html
// module id = 434
// module chunks = 1